import { Controller } from "stimulus"

export default class extends Controller {
  static values = { itemPaths: String }

  connect() {
    const itemPaths = this.itemPathsValue;
    Utilities.inputFile();
    Utilities.initCourseTinymce(itemPaths);
    Utilities.initCocoon();
    Utilities.initSortable();
    Utilities.triggerToggleVisibility();
    Utilities.setDefaultVisibility();
    Courses.toggleSaveButtonVisibility();
    Utilities.hideFileUploadWhileUploading();

    Utilities.handleEvent('.js-lesson-form', 'cocoon:after-insert', () => {
      Utilities.inputFile();
    });

    const sectionId = this.element.dataset.selectedItemSectionIdValue;
    if (sectionId) {
      const details = document.querySelector(`details.js-item-sortable[data-id="${sectionId}"]`);
      if (details) details.setAttribute('open', '');
    }
  }
}
